var selectValue = "*";

// Go through checkbox and return selected
function setInclusives() {
  var inclusives = [];
  $( '#filter-units input' ).each( function( i, elem ) {
    if ( elem.checked ) { inclusives.push( elem.value + selectValue ); }
  });
  return inclusives.length ? inclusives.join( ', ' ) : selectValue;
}

// Find an URL parameter
function getParam( param ) {
  var name, vars = decodeURIComponent(window.location.search.substring(1)).split( '&' );
  for (var i = 0; i < vars.length; i++) {
    name = vars[i].split( '=' );
    if (name[0] === param) { return name[1] === undefined ? true : name[1]; }
  }
}

$(function ($) {

  if( $( '.isotope' ).length ) {

    // Init isotope
    var isotope = $( '.isotope' ).isotope({
      itemSelector: '.event',
      layoutMode: 'fitRows'
    });

    // Select events for a specified unit in URL
    if ( $( '#' + getParam( 'u' ) ) ) {
      $( '#' + getParam( 'u' ) ).prop( 'checked', true );
      isotope.isotope({ filter: setInclusives() });
    }

    // Filter by month with select
    $( '#filter-month' ).on( 'change', function() {
      selectValue = this.value;
      isotope.isotope({ filter: setInclusives() });
    });

    // Filter by units with checkbox
    $( '#filter-units input' ).on( 'change', function() {
      isotope.isotope({ filter: setInclusives() });
    });

  }

});
